import { AxiosResponse } from 'axios'
import React, { SyntheticEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../../../App/Components/Button/Button'
import Checkbox from '../../../App/Components/Checkbox/Checkbox'
import Spinner from '../../../App/Components/Spinner/Spinner'
import { IEstablishment } from '../../../Establishment/interface/IEstablishment'
import { IUser } from '../../DataStore/IUser'
import LoginClient from '../Client/LoginClient'
import { InputField } from '../components/InputField'

import style from './style.scss'

type Props = {
  establishment: IEstablishment
  user: IUser
}

const Password: React.FC<Props> = ({ establishment, user }) => {
  const [password, setPassword] = useState<string>('')
  const [rememberMe, setRememberMe] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)
  const [loggingIn, setLoggingIn] = useState<boolean>(false)
  const { t } = useTranslation(['messages', 'security'])

  const onSubmit = (e: SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault()

    if (password.length === 0) {
      setError('Password is required')
      return
    }

    setLoggingIn(true)

    LoginClient.login(establishment, user, password, rememberMe ? 'on' : '')
      .then((response: AxiosResponse) => {
        window.location.replace(response.data.redirect_url)
      })
      .catch(error => {
        const errorResponse = error.response.data.error
        setError(
          t(
            'security;;' + errorResponse.message_key,
            errorResponse.message_data,
          ),
        )
        setLoggingIn(false)
      })
  }

  return (
    <div className={style.passwordWrapper}>
      <div className={style.user}>
        <div className={style.avatar}>
          <img src={`${user.avatar}&w=50&h=50&fit=crop`} alt="user" />
        </div>
        {user.firstName}
      </div>
      {loggingIn ? (
        <Spinner className={style.spinner} />
      ) : (
        <>
          <form onSubmit={onSubmit} method={'post'}>
            <InputField
              onChange={e => setPassword(e.currentTarget.value)}
              value={password}
              error={error}
              type="password"
              autoFocus
            />
            <Checkbox
              label={t('Keep me logged in')}
              onChange={setRememberMe}
              isChecked={rememberMe}
            />
            <div className={style.submitButton}>
              <Button type={'submit'}>{t('Login')}</Button>
            </div>
          </form>
        </>
      )}
    </div>
  )
}

export default Password
